import React from 'react';
import styles from './PFSFooterNav.module.css';

import ContentContainer from '../ContentContainer/ContentContainer';
import QBIcon from '../QBIcon/QBIcon';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYelp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const PFSFooterNav = () => (
  <div className={styles.PFSFooterNav} data-testid='PFSFooterNav'>
    <ContentContainer>
      <div className={styles.FooterNavContainer}>
        <div className={styles.NavSection}>
          <div className={styles.NavSectionHeader}>Company</div>
          <div className={styles.NavSectionTwoColumns}>
            <ul className={styles.NavSectionList}>
              <li><Link to={'/'}>Home</Link></li>
              <li><Link to={'/what-we-do'}>What We Do</Link></li>
              <li><Link to={'/who-we-are'}>Who We Are</Link></li>
            </ul>
            <ul className={styles.NavSectionList}>
              <li><Link to={'/articles'}>What We Think</Link></li>
              <li><Link to={'/who-we-trust'}>Who We Trust</Link></li>
            </ul>
          </div>
        </div>
        <div className={styles.NavSection}>
          <div className={styles.NavSectionHeader}>Get in Touch</div>
          <ul className={styles.NavSectionList}>
            <li><Link to={'/contact'}>Contact Us</Link></li>
            <li><Link to={'/careers'}>Careers</Link></li>
          </ul>
        </div>
        <div className={styles.NavSection}>
          <div className={styles.NavSectionHeader}>Tools</div>
          <ul className={styles.NavSectionList}>
            <li><Link to={'/what-we-do/TaxOps#tools'}>Tax Tools</Link></li>
            <li><a href='https://portal.pfsonline.com/client-login' target='_blank' rel='noopener noreferrer'>FinOps Portal</a></li>
          </ul>
        </div>
        <div className={styles.NavSection}>
          <div className={styles.NavSectionHeader}>Follow Us</div>
          <div id={styles.NavIconSection} className={styles.FollowUsIcons}>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://facebook.com/pfsglobal1'
              className={styles.SocialIcon}
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://www.instagram.com/pfsglobal1/'
              className={styles.SocialIcon}
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://twitter.com/PFSglobal1'
              className={styles.SocialIcon}
            >
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://www.linkedin.com/company/pfsglobal1'
              className={styles.SocialIcon}
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://www.youtube.com/channel/UCf3jPS8lu2v-wUjNy6bnD8w'
              className={styles.SocialIcon}
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://proadvisor.intuit.com/app/accountant/search?searchId=aaron-c-stocks'
              className={styles.SocialIcon}
            >
              <QBIcon />
            </a>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://www.yelp.com/biz/pfs-global-diamond-bar'
              className={styles.SocialIcon}
            >
              <FontAwesomeIcon icon={faYelp} />
            </a>
          </div>
        </div>
      </div>
    </ContentContainer>
  </div>
);

PFSFooterNav.propTypes = {};

export default PFSFooterNav;
